import { C } from '../../lib/tokens.js';

export function SectionCard({ title, children }) {
  return (
    <div style={{ background: C.tin, border: `1px solid ${C.mercury}`, borderRadius: 6, overflow: 'hidden', marginBottom: 20 }}>
      <div style={{ padding: '12px 20px', borderBottom: `1px solid ${C.mercury}`, background: C.chrome }}>
        <span style={{ fontSize: 11, fontWeight: 500, color: C.iron, textTransform: 'uppercase', letterSpacing: '0.06em' }}>{title}</span>
      </div>
      <div style={{ padding: 20 }}>{children}</div>
    </div>
  );
}
